/* ==========================================================================
   gotu-banner7.js
   JavaScript do snippet banner7-frontpage.liquid, tirado de dentro do HTML a 2026-07-30.

   Porque: eram 12 KB de JS inline, a viajar outra vez em cada vista da
   homepage e sem hipotese de ser cacheado. Aqui e descarregado uma vez.

   Carregado com defer a partir do proprio snippet, e nao do theme.liquid,
   para so existir nas paginas onde o banner existe.

   Conteudo copiado tal e qual. Zero Liquid la dentro.
   ========================================================================== */

  (function() {
    const bannerRoot = document.getElementById('op-banner-root');
    const productsHolder = document.getElementById('op-products-holder');
    const viewport = document.getElementById('op-carousel-viewport');
    const track = document.getElementById('op-products-holder');
    const dotsContainer = document.getElementById('op-carousel-dots');
    const prevBtn = document.getElementById('op-prev-btn');
    const nextBtn = document.getElementById('op-next-btn');
    
    const hasLiquidStart = '{' + '%';
    const hasLiquidOutput = '{' + '{';

    // Count how many cards compiled server-side
    const serverRenderedCards = productsHolder ? productsHolder.querySelectorAll('.op-product-card-wrapper').length : 0;

    // Trigger mock cards if 0 cards rendered OR if Liquid syntax itself is uncompiled
    const isMockRequired = serverRenderedCards === 0 || 
                           bannerRoot.dataset.liquidRendered === "false" || 
                           document.getElementById('op-fallback-status') !== null ||
                           bannerRoot.innerHTML.includes(hasLiquidStart) || 
                           bannerRoot.innerHTML.includes(hasLiquidOutput);

    if (isMockRequired) {
      console.log("Visualização Premium Ativada.");
      
      const ctaLink = document.getElementById('op-cta-link');
      if (ctaLink) ctaLink.href = "https://gotu.pt/collections/ultimas-oportunidades";

      const mockProducts = [
        {
          title: "Calçado Barefoot Primavera Confort",
          url: "https://gotu.pt/collections/ultimas-oportunidades",
          image: "https://images.unsplash.com/photo-1591130901013-e58a09753a14?auto=format&fit=crop&w=400&q=80",
          price: "41,25 €",
          comparePrice: "55,00 €",
          stock: 4,
          progressWidth: "50%",
          label: "Apenas 4 restantes!",
          sizes: ["24", "25", "26", "27"]
        },
        {
          title: "Brinquedo de Construção Magnética Pastel (120 peças)",
          url: "https://gotu.pt/collections/ultimas-oportunidades",
          image: "https://images.unsplash.com/photo-1587654780291-39c9404d746b?auto=format&fit=crop&w=400&q=80",
          price: "89,25 €",
          comparePrice: "119,00 €",
          stock: 2,
          progressWidth: "45%",
          label: "Apenas 2 restantes!",
          sizes: ["Único"]
        },
        {
          title: "Sandália Barefoot Confort Flex Infantil",
          url: "https://gotu.pt/collections/ultimas-oportunidades",
          image: "https://images.unsplash.com/photo-1591130901013-e58a09753a14?auto=format&fit=crop&w=400&q=80",
          price: "34,99 €",
          comparePrice: "46,65 €",
          stock: 3,
          progressWidth: "37%",
          label: "Apenas 3 restantes!",
          sizes: ["25", "26", "27", "29", "30"]
        },
        {
          title: "Câmara Fotográfica Infantil de Madeira Amarela",
          url: "https://gotu.pt/collections/ultimas-oportunidades",
          image: "https://images.unsplash.com/photo-1515488042361-404e9250afef?auto=format&fit=crop&w=400&q=80",
          price: "29,99 €",
          comparePrice: "39,99 €",
          stock: 1,
          progressWidth: "12%",
          label: "Apenas 1 artigo restante!",
          sizes: ["Padrão"]
        },
        {
          title: "Puzzle Progressivo Animais da Floresta",
          url: "https://gotu.pt/collections/ultimas-oportunidades",
          image: "https://images.unsplash.com/photo-1587654780291-39c9404d746b?auto=format&fit=crop&w=400&q=80",
          price: "14,99 €",
          comparePrice: "19,99 €",
          stock: 5,
          progressWidth: "62%",
          label: "Apenas 5 restantes!",
          sizes: ["Único"]
        },
        {
          title: "Sapato Barefoot Flexível Casual Camurça",
          url: "https://gotu.pt/collections/ultimas-oportunidades",
          image: "https://images.unsplash.com/photo-1591130901013-e58a09753a14?auto=format&fit=crop&w=400&q=80",
          price: "48,75 €",
          comparePrice: "65,00 €",
          stock: 1,
          progressWidth: "12%",
          label: "Apenas 1 artigo restante!",
          sizes: ["24", "25", "26", "27"]
        }
      ];

      let productsHtml = '';
      mockProducts.forEach(prod => {
        let sizesHtml = '';
        if (prod.sizes && prod.sizes.length > 0) {
          sizesHtml = `
            <div class="op-size-selector-wrapper">
              <div class="op-size-chips-track">
                ${prod.sizes.map((size) => {
                  let chipClass = (size === "27") ? 'active' : 'available';
                  return `<span class="op-size-chip ${chipClass}">${size}</span>`;
                }).join('')}
              </div>
            </div>
          `;
        }

        productsHtml += `
          <div class="op-product-card-wrapper">
            <a href="${prod.url}" class="op-product-card" target="_blank">
              <div class="op-product-media">
                <img src="${prod.image}" alt="${prod.title}" style="display:block;">
              </div>
              <div class="op-product-details">
                <h3 class="op-product-title">${prod.title}</h3>
                
                ${sizesHtml}

                <div class="op-price-block">
                  <span class="op-price-sale">${prod.price}</span>
                  <span class="op-price-compare">${prod.comparePrice}</span>
                </div>
                <div class="op-urgency-meter">
                  <div class="op-urgency-labels">
                    <span class="op-urgency-left-label">${prod.label}</span>
                    <span class="op-urgency-right-label">Últimos itens</span>
                  </div>
                  <div class="op-meter-bar">
                    <div class="op-meter-progress" style="width: ${prod.progressWidth};"></div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        `;
      });

      productsHolder.innerHTML = productsHtml;
    }

    // --- Native Scroll Carousel System ---
    let autoSlideTimer = null;

    function shuffleDOMCards() {
      const cards = Array.from(track.querySelectorAll('.op-product-card-wrapper'));
      if (cards.length <= 1) return;
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        track.appendChild(cards[j]);
      }
    }

    function getCardWidth() {
      const card = track.querySelector('.op-product-card-wrapper');
      return card ? card.offsetWidth : 280;
    }

    function buildCarouselPagination() {
      dotsContainer.innerHTML = '';
      const cards = track.querySelectorAll('.op-product-card-wrapper');
      if (cards.length === 0) return;

      const pageWidth = viewport.clientWidth;
      if (pageWidth <= 0) return; // Prevention check for division by zero

      const cardWidth = getCardWidth();
      const totalScrollable = viewport.scrollWidth - pageWidth;
      
      if (totalScrollable <= 0) {
        const controls = document.getElementById('op-carousel-controls');
        if (controls) controls.style.display = 'none';
        return;
      } else {
        const controls = document.getElementById('op-carousel-controls');
        if (controls) controls.style.display = 'flex';
      }

      // Calculate snapping-friendly steps
      const visibleCards = Math.max(1, Math.floor(pageWidth / cardWidth));
      const scrollStep = visibleCards * cardWidth;
      const numPages = Math.ceil(totalScrollable / scrollStep) + 1;

      for (let i = 0; i < numPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'op-carousel-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        
        dot.addEventListener('click', function() {
          const targetScroll = Math.min(i * scrollStep, totalScrollable);
          viewport.scrollTo({ left: targetScroll, behavior: 'smooth' });
          resetCarouselTimer();
        });
        dotsContainer.appendChild(dot);
      }
    }

    function updateActiveSlideIndicator() {
      const pageWidth = viewport.clientWidth;
      if (pageWidth <= 0) return;

      const cardWidth = getCardWidth();
      const visibleCards = Math.max(1, Math.floor(pageWidth / cardWidth));
      const scrollStep = visibleCards * cardWidth;
      
      const currentScroll = viewport.scrollLeft;
      const pageIndex = Math.round(currentScroll / scrollStep);
      
      const dots = dotsContainer.querySelectorAll('.op-carousel-dot');
      dots.forEach((dot, index) => {
        if (index === pageIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    function advanceToNextSlide() {
      const cards = track.querySelectorAll('.op-product-card-wrapper');
      if (cards.length === 0) return;
      
      const pageWidth = viewport.clientWidth;
      if (pageWidth <= 0) return;

      const cardWidth = getCardWidth();
      const totalScrollable = viewport.scrollWidth - pageWidth;
      if (totalScrollable <= 0) return;

      const visibleCards = Math.max(1, Math.floor(pageWidth / cardWidth));
      const scrollStep = visibleCards * cardWidth;

      // Mathematically normalize standard starting point to closest card snap bounds
      const normalizedScroll = Math.round(viewport.scrollLeft / cardWidth) * cardWidth;
      let nextScroll = normalizedScroll + scrollStep;

      // Safe transition edge detection
      if (nextScroll >= totalScrollable + 10) {
        track.style.opacity = '0';
        setTimeout(() => {
          shuffleDOMCards();
          viewport.scrollLeft = 0;
          updateActiveSlideIndicator();
          
          setTimeout(() => {
            track.style.opacity = '1';
          }, 50);
        }, 300);
      } else {
        viewport.scrollTo({ left: nextScroll, behavior: 'smooth' });
      }
    }

    function startCarouselTimer() {
      clearInterval(autoSlideTimer);
      autoSlideTimer = setInterval(advanceToNextSlide, 3000);
    }

    function resetCarouselTimer() {
      startCarouselTimer();
    }

    // Bind Scroll Listeners
    viewport.addEventListener('scroll', updateActiveSlideIndicator);

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function() {
        const cardWidth = getCardWidth();
        const pageWidth = viewport.clientWidth;
        const visibleCards = Math.max(1, Math.floor(pageWidth / cardWidth));
        const scrollStep = visibleCards * cardWidth;
        
        const normalizedScroll = Math.round(viewport.scrollLeft / cardWidth) * cardWidth;
        viewport.scrollTo({ left: normalizedScroll - scrollStep, behavior: 'smooth' });
        resetCarouselTimer();
      });
      nextBtn.addEventListener('click', function() {
        advanceToNextSlide();
        resetCarouselTimer();
      });
    }

    // Pause Carousel on interaction (ensures mobile swipe releases safely)
    function pauseTimer() {
      clearInterval(autoSlideTimer);
    }

    function resumeTimer() {
      startCarouselTimer();
    }

    viewport.addEventListener('pointerdown', pauseTimer);
    viewport.addEventListener('pointerup', resumeTimer);
    viewport.addEventListener('pointercancel', resumeTimer);

    // Initial construction and execution
    shuffleDOMCards();
    buildCarouselPagination();
    startCarouselTimer();

    // Responsive adaptation on Resize
    let initialWidth = window.innerWidth;
    window.addEventListener('resize', function() {
      const currentWidth = window.innerWidth;
      if (initialWidth !== currentWidth) {
        buildCarouselPagination();
        initialWidth = currentWidth;
      }
    });

  })();
